import http from '../api/http';

export default {
    getAreas({callback}){
        http.get(`/doshii/terminals`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    alterAreas({params, callback}){
        http.post(`/doshii/terminals`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    progress({callback}){ // 步骤状态
        http.get(`/v1/home/stepStatus`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/income.js